<template>
  <!-- 数据统计时间筛选组件 -->
  <div>
    <Tabs class="tabs" title="商户管理" />
    <div class="box">
      <div class="title">经营资料</div>
      <div>
        <blue-title class="style">营业执照</blue-title>
        <div>
          <div class="info">
            <span class="marRight">商户简称</span><span>{{ businessData.merchantShortname }}</span>
          </div>
          <div class="info">
            <span class="marRight">客服电话</span><span>{{ businessData.servicePhone }}</span>
          </div>
        </div>
      </div>
      <div>
        <blue-title class="style">线下门店</blue-title>
        <div>
          <div class="info">
            <span class="marRight">门店名称</span><span>{{ businessData.bizStoreName }}</span>
          </div>
          <div class="info">
            <span class="marRight">门店省市</span><span>{{ businessData.bizAddressCode }}</span>
          </div>
          <div class="info">
            <span class="marRight">门店地址</span><span>{{ businessData.bizStoreAddress }}</span>
          </div>
          <div class="info" style="height: 70px">
            <span class="marRight">门店门头照片</span
            ><span
              ><el-image :src="businessData.storeEntrancePic" alt="" style="width: 58px; height: 58px"></el-image
            ></span>
          </div>
          <div class="info" style="height: 70px">
            <span class="marRight">店内环境照片</span
            ><span><el-image :src="businessData.indoorPic" alt="" style="width: 58px; height: 58px"></el-image></span>
          </div>
          <div class="info">
            <span class="marRight">线下场所对应的商家APPID</span><span>{{ businessData.bizSubAppid }}</span>
          </div>
        </div>
      </div>
      <div class="btn">
        <el-button type="info" @click="back">返回</el-button>
        <el-button type="primary" @click="next">下一页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { draftEcho } from '../../../../api/module/merchants';
export default {
  components: {},
  props: {},
  data() {
    return {
      businessData: {},
    };
  },
  computed: {
    uuid() {
      return this.$route.query.uuid;
    },
  },
  watch: {},
  created() {
    this.draftEcho();
  },
  methods: {
    back() {
      this.$router.push({
        path: '/merchants',
      });
    },
    next() {
      const { uuid } = this;
      this.$router.push({
        path: '/merchants/businessDetails',
        query: {
          uuid,
        },
      });
    },
    async draftEcho() {
      const { uuid } = this;
      const result = await draftEcho({
        uuid,
      });
      this.businessData = result.businessDataVO;
      console.log('回显所填信息', result);
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  background-color: white;
  box-sizing: border-box;
  padding: 20px;
  height: 100%;
  .title {
    font-size: 16px;
    color: #333;
    font-weight: 500;
  }
  .style {
    font-size: 12px;
    color: #333;
    font-weight: 500;
    margin: 9px 0 20px 0;
  }
  .info {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #333;
    font-weight: 500;
    height: 42px;
    border-bottom: 1px solid #e5e5e5;
  }
  .marRight {
    width: 90px;
    margin-right: 38px;
  }
  .btn {
    margin-top: 50px;
  }
}
</style>
